import { motion, type HTMLMotionProps } from 'motion/react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils.js';
import { pageTransition } from '@/lib/motion.js';

export type PageTransitionProps = HTMLMotionProps<'div'>;

/**
 * Wrapper for Route elements when used inside <AnimatePresence mode="wait">.
 *
 * @example
 * <Route path="/x" element={<PageTransition><MyPage/></PageTransition>} />
 */
export const PageTransition = forwardRef<HTMLDivElement, PageTransitionProps>(
  function PageTransition({ className, children, ...rest }, ref) {
    return (
      <motion.div
        ref={ref}
        variants={pageTransition}
        initial="initial"
        animate="animate"
        exit="exit"
        className={cn('w-full', className)}
        {...rest}
      >
        {children}
      </motion.div>
    );
  },
);
